
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Models
import {AppCommonExercise} from "@/models/app/common/exercise";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import {InfoFilled} from "@element-plus/icons-vue";
import AppCoachResourcesRootExercisesFormLookupVue from "@/views/app/coach/resources/root/exercises/form/lookup.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    InfoFilled,
    AppCoachResourcesRootExercisesFormLookupVue,
  },
})
export default class AppCoachResourcesRootExercisesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  exercises: Array<AppCommonExercise> = [];

  async getExercises(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/exercises`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.exercises = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getExercises();
  }
}
